module.exports = __webpack_public_path__ + "img/ttf.e7809408.svg";